import styled from 'styled-components';
import { display, position, DisplayProps, PositionProps } from 'styled-system';

import { TestIdProps, withTestIdProp } from '../../../utils';

export interface FormProps extends TestIdProps, DisplayProps, PositionProps {}

export const Form = styled('form').attrs(withTestIdProp)<FormProps>(display, position);
